import { View, Text } from '@react-pdf/renderer'

import styles from '../../style'
import tableStyles from './tableStyles'
import Row from './Row'

interface ServiceInfo {
  costShare: string
  deductibleApplies: boolean
}

export interface IServices {
  primary: ServiceInfo
  specialist: ServiceInfo
  virtual: ServiceInfo
  preventive: ServiceInfo
  urgent: ServiceInfo
  emergency: ServiceInfo
  inpatient: ServiceInfo
  generics: ServiceInfo
  preferredBrand: ServiceInfo
  nonPreferredBrand: ServiceInfo
  specialtyHighCost: ServiceInfo
  OPPro: ServiceInfo
  mentalHealthPro: ServiceInfo
  speechTherapyPro: ServiceInfo
  physicalTherapyPro: ServiceInfo
  labPro: ServiceInfo
  xRaySpecialist: ServiceInfo
  xRayPrimary: ServiceInfo
  xRayUnclass: ServiceInfo
  ImagingPro: ServiceInfo
  outpatient: ServiceInfo
  mentalHealthFac: ServiceInfo
  speechTherapyFac: ServiceInfo
  physicalTherapyFac: ServiceInfo
  labFac: ServiceInfo
  imagingFac: ServiceInfo
  skilledNursing: ServiceInfo
  unclassified: ServiceInfo
}

interface IServiceTable {
  services: IServices
}

const serviceTitles: { name: string; accessor: keyof IServices }[] = [
  {
    name: 'Primary Care (Office)',
    accessor: 'primary'
  },
  {
    name: 'Specialist (Office)',
    accessor: 'specialist'
  },
  {
    name: 'Virtual Care',
    accessor: 'virtual'
  },
  {
    name: 'Preventive Care',
    accessor: 'preventive'
  },
  {
    name: 'Urgent Care',
    accessor: 'urgent'
  },
  {
    name: 'Emergency Room',
    accessor: 'emergency'
  },
  {
    name: 'Inpatient Facility',
    accessor: 'inpatient'
  },
  {
    name: 'Generics',
    accessor: 'generics'
  },
  {
    name: 'Preferred Brand',
    accessor: 'preferredBrand'
  },
  {
    name: 'Non-Preferred Brand',
    accessor: 'nonPreferredBrand'
  },
  {
    name: 'Specialty High-Cost',
    accessor: 'specialtyHighCost'
  },
  {
    name: 'OP Professional',
    accessor: 'OPPro'
  },
  {
    name: 'Mental Health - OP Prof.',
    accessor: 'mentalHealthPro'
  },
  {
    name: 'Speech Therapy - OP Prof.',
    accessor: 'speechTherapyPro'
  },
  {
    name: 'Physical / Occupational Therapy - OP Prof.',
    accessor: 'physicalTherapyPro'
  },
  {
    name: 'Laboratory - OP Prof.',
    accessor: 'labPro'
  },
  {
    name: 'X-rays (Specialist)',
    accessor: 'xRaySpecialist'
  },
  {
    name: 'X-rays (Primary)',
    accessor: 'xRayPrimary'
  },
  {
    name: 'X-rays (Unclass.)',
    accessor: 'xRayUnclass'
  },
  {
    name: 'Imaging - OP Prof.',
    accessor: 'ImagingPro'
  },
  {
    name: 'Outpatient Facility',
    accessor: 'outpatient'
  },
  {
    name: 'Mental Health - OP Facility',
    accessor: 'mentalHealthFac'
  },
  {
    name: 'Speech Therapy - OP Facility',
    accessor: 'speechTherapyFac'
  },
  {
    name: 'Physical / Occupational Therapy - OP Facility',
    accessor: 'physicalTherapyFac'
  },
  {
    name: 'Laboratory - OP Facility',
    accessor: 'labFac'
  },
  {
    name: 'Imaging - OP Facility',
    accessor: 'imagingFac'
  },
  {
    name: 'Skilled Nursing Facility',
    accessor: 'skilledNursing'
  },
  {
    name: 'Unclassified',
    accessor: 'unclassified'
  }
]

const ServiceTable = ({ services }: IServiceTable) => {
  return (
    <View
      style={{
        display: 'flex',
        width: '100%'
      }}
    >
      <View style={[styles.row, { marginTop: 0, paddingVertical: 4 }]}>
        <Text
          style={[
            tableStyles.serviceCol,
            styles.descriptionText,
            tableStyles.cellText
          ]}
        >
          Services
        </Text>
        <Text
          style={[
            tableStyles.costShareCol,
            styles.descriptionText,
            tableStyles.cellText
          ]}
        >
          Cost Share
        </Text>
        <Text
          style={[
            tableStyles.deductibleCol,
            styles.descriptionText,
            tableStyles.cellText
          ]}
        >
          Deductible Applies
        </Text>
      </View>
      {serviceTitles.map(({ name, accessor }, index) => (
        <Row
          key={name}
          service={name}
          serviceInfo={services[accessor]}
          rowIndex={index}
        />
      ))}
    </View>
  )
}

export default ServiceTable
